<template>
<div class="create px-12 py-8">
    <lCrumbs :breadcrumb="breadcrumbItems" />
    <div>
        <div class="text-center md:text-left mb-8 text-2xl font-bold page-heading">
            New Learner
        </div>
        <div class="md:flex w-full">
            <div class="w-full md:w-1/2">
                <div class="md:mx-12">
                    <div class="item md:flex md:items-center w-full mb-12">
                        <div class="w-full md:w-1/4 mr-4">
                            <label class="text-black font-bold" for="">First Name: </label>
                        </div>
                        <div class="w-full">
                            <linput type="text" name="first_name" v-model="form.first_name" :errorMessage="errors.first_name" :error="errors.first_name" placeholder="First Name" />
                        </div>
                    </div>
                    <div class="item md:flex md:items-center w-full mb-12">
                        <div class="w-full md:w-1/4 mr-4">
                            <label class="text-black font-bold" for="">Last Name: </label>
                        </div>
                        <div class="w-full">
                            <linput type="text" name="lname" v-model="form.last_name" :errorMessage="errors.last_name" :error="errors.last_name" placeholder="Last Name" />
                        </div>
                    </div>
                    <div class="item md:flex md:items-center w-full mb-12">
                        <div class="w-full md:w-1/4 mr-4">
                            <label class="text-black font-bold" for="">Email: </label>
                        </div>
                        <div class="w-full">
                            <linput type="email" name="email" v-model="form.email" :errorMessage="errors.email" :error="errors.email" placeholder="Email Address" />
                        </div>
                    </div>
                    <div class="item md:flex md:items-center w-full mb-12">
                        <div class="w-full md:w-1/4 mr-4">
                            <label class="text-black font-bold" for="">Phone: </label>
                        </div>
                        <div class="w-full">
                            <linput type="text" name="phone" v-model="form.phone_number" :errorMessage="errors.phone_number" :error="errors.phone_number" placeholder="Phone Number" />
                        </div>
                    </div>
                    <div class="item md:flex md:items-center w-full mb-12">
                        <div class="w-full md:w-1/4 mb-2 md:mb-0 mr-4">
                            <label class="text-black font-bold" for="">Gender: </label>
                        </div>
                        <div class="w-full">
                            <div>
                                <input type="radio" name="course-landing" v-model="form.gender" value="male" />
                                Male
                                <input type="radio" name="course-landing" v-model="form.gender" value="female" />
                                Female
                            </div>
                        </div>
                    </div>

                    <!-- <div class="w-full my-3 md:w-1/2 flex">
                        <div class="mx-2 mt-2 modal-field font-semibold">
                            Select Program:
                        </div>
                        <div class="flex-grow ml-auto">
                            <div class="inline-block relative w-64">
                                <select v-model="id" class="block appearance-none w-full   bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                                    <option :value="undefined">Select Program</option>
                                    <option :value="program.value" v-for="(program, idx) in getPrograms" :key="idx">{{ program.text }}</option>
                                </select>
                                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="item md:flex md:items-center w-full mb-12">
                        <div class="w-full md:w-1/4 mb-2 md:mb-0 mr-4">
                            <label class="text-black font-bold" for="">Program (optional): </label>
                        </div>
                        <div class="flex-grow ml-auto">
                            <lselect :error="errors.type" v-model="form.program" :items="getPrograms" :errorMessage="errors.program" placeholder="Select Program" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full md:w-1/2">
                <div class="md:mx-12">
                    <div class="item md:flex md:items-center w-full mb-12">
                        <div class="w-full md:w-1/4 mr-4">
                            <label class="text-black font-bold" for="">Learner Image (optional):
                            </label>
                        </div>
                        <div>
                            <vue-dropzone @vdropzone-drag-drop="form.student_image = $event" @vdropzone-file-added="form.student_image = $event" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                            <small class="text-red-500" v-if="errors.student_image">The learner image field is required</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mx-auto text-center mb-6 import">
            <span class="mr-2"><i class="fas fa-upload fa-2x"></i></span>Import bulk
            from csv instead
            <input ref="file" @change="selectFile" type="file" />
        </div>
        <div class="text-center">
            <div>
                <lbutton class="mb-4" @click="addLearner">Add Learner </lbutton>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapMutations,
    mapGetters
} from "vuex";
import FormActions from "@/mixins/FormActions";
import Api from "@/utils/api";
export default {
    mixins: [FormActions],
    data() {
        return {
            form: {},
            errors: {},
            file: "",
            breadcrumbItems: [{
                    disabled: true,
                    to: "/tenant/users/",
                    text: "All Learners",
                },
                {
                    disabled: true,
                    to: "/tenant/users/create",
                    text: "Create Learner",
                },
            ],
        };
    },
    computed: {
        ...mapGetters(["getTenantPrograms"]),
        getPrograms() {
            //console.log(this.getTenantPrograms);
            let programs = this.getTenantPrograms;
            let sortedPrograms = [];
            for (let i = 0; i < programs.length; i++) {
                let temp = {
                    text: programs[i].title,
                    value: programs[i].id,
                };
                //console.log(temp);
                sortedPrograms = sortedPrograms.concat(temp);
            }
            //console.log(sortedPrograms);
            return sortedPrograms;
        },
    },
    methods: {
        ...mapActions(["tenantCreateUser", "fetchTenantPrograms"]),
        ...mapMutations(["updateLoader"]),
        selectFile() {
            this.file = this.$refs.file.files;
        },
        async bulkAdd() {
            this.errors = [];
            //console.log({ gg: this.file });
            let payload = new FormData();
            payload.append("file", this.file[0]);
            this.updateLoader(true);
            localStorage.setItem("use-backup-api", "true");
            let res = await Api.post(`tenant/user/bulk/create`, payload, true);
            localStorage.setItem("use-backup-api", "false");
            this.updateLoader(false);
            if (res.status == 200 || res.status == 201) {
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Learner created successfully",
                });

                this.$router.push({
                    name: "tenant-users-home",
                });
            } else {
                this.errors = res.data.errors[0].source;
                console.log(this.errors)
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        // this.errors : "An Error Occured"
                        "A Problem Occured While Processing your app.. this is probably due to improper csv data uploaded. kindly check your email for better information regardng the error" : "An Error Occured"
                });
            }
        },
        async addLearner() {
            if (this.file) {
                return this.bulkAdd();
            }
            this.errors = [];
            this.updateLoader(true);
            if (this.form.student_image) {
                this.form.student_image = await this.uploadFile(
                    this.form.student_image
                );
            } else {
                this.form.student_image = "";
            }
            let res = await this.tenantCreateUser(this.form);
            this.updateLoader(false);
            if (res.status == 200 || res.status == 201) {
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Learner created successfully",
                });

                this.$router.push({
                    name: "tenant-users-home",
                });
            } else {
                this.errors = res.data.errors[0].source;
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title : "An error occured",
                });
            }
        },
    },
    components: {
        linput: () => import("@/components/general/input"),
        lbutton: () => import("@/components/general/button"),
        lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
        lselect: () => import("@/components/forms/select"),
    },

    mounted() {
        ///this.fetchTenantPrograms();
    }
};
</script>

<style lang="scss" scoped>
.dropzone {
    min-height: 8px;
    padding: 4px 10px;
    border-style: dotted solid;
}
</style>
